"use client";

import {
  Table as ChakraTable,
  type TableRootProps,
  type HTMLChakraProps
} from "@chakra-ui/react";

export type TableProps = TableRootProps & {
  variant?: TableRootProps["variant"] | "simple" | string;
};

export function Table({ variant, ...props }: TableProps) {
  // v2 alias: "simple" → v3 "line" (otherwise the table renders unstyled).
  const resolvedVariant = variant === "simple" ? "line" : variant;
  return (
    <ChakraTable.Root
      variant={resolvedVariant as TableRootProps["variant"]}
      {...props}
    />
  );
}

export function Thead(props: HTMLChakraProps<"thead">) {
  return <ChakraTable.Header {...props} />;
}

export function Tbody(props: HTMLChakraProps<"tbody">) {
  return <ChakraTable.Body {...props} />;
}

export function Tfoot(props: HTMLChakraProps<"tfoot">) {
  return <ChakraTable.Footer {...props} />;
}

export function Tr(props: HTMLChakraProps<"tr">) {
  return <ChakraTable.Row {...props} />;
}

export function Th(props: HTMLChakraProps<"th"> & { isNumeric?: boolean }) {
  const { isNumeric, ...rest } = props;
  return (
    <ChakraTable.ColumnHeader
      textAlign={isNumeric ? "end" : undefined}
      {...rest}
    />
  );
}

export function Td(props: HTMLChakraProps<"td"> & { isNumeric?: boolean }) {
  const { isNumeric, ...rest } = props;
  return (
    <ChakraTable.Cell textAlign={isNumeric ? "end" : undefined} {...rest} />
  );
}

export function TableContainer(props: HTMLChakraProps<"div">) {
  return <ChakraTable.ScrollArea {...props} />;
}

export function TableCaption(props: HTMLChakraProps<"caption">) {
  return <ChakraTable.Caption {...props} />;
}

export const TableComponentStyle = {};
